import React, { useState } from "react";
import {
  Autocomplete,
  Box,
  Chip,
  Grid,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid"; // ✅ Import Grid correctly
import { CloudUpload, Delete } from "@mui/icons-material";

// Custom Components
import MaterialTypography from "../MaterialTypography";
import MaterialInput from "../MaterialInput";
import MaterialSelect from "../MaterialSelect";

const NewFile = ({ newFile, setNewFile,handleFileChange,selectedFiles,projectList,handleProjectChange,teamMembersData,handleReadMemberFileChange,handleWriteFileMemberChange }) => {


  return (
    <Grid container spacing={2}>
      {/* File Name */}
      <Grid size={{ xs: 12, sm: 12, md: 12 }}>
        <Stack direction="column" spacing={1}>
          <MaterialTypography variant="caption" color="dark">
            File name
          </MaterialTypography>
          <MaterialInput
            name="fileName"
            placeholder="Enter file name"
            value={newFile.name}
            // onChange={(e) => setNewFile({ ...newFile, name: e.target.value })}
              onChange={(e) =>
          setNewFile({...newFile,name:e.target.value})}
          />
        </Stack>
      </Grid>

    
      {/* Read Permission */}
      <Grid size={{xs:12,sm:12,md:12}}>
        <Stack direction="column" spacing={1}>
          <MaterialTypography variant="caption" color="dark">
            Read Permission
          </MaterialTypography>
          <Autocomplete
            multiple
            id="tags-outlined"
            options={teamMembersData || []}
            getOptionLabel={(option) =>
              `${option?.employee_name || ""} (${option?.team || "No Team"})`
            }
            value={newFile.readPermission || []}
            onChange={handleReadMemberFileChange}
            filterSelectedOptions
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  key={option?.id || index}
                  label={`${option?.employee_name || ""} (${option?.team || "NO Team"})`}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} placeholder="Add read members" />
            )}
          />
        </Stack>
      </Grid>

      {/* Write Permission */}
      <Grid size={{xs:12,sm:12,md:12}}>
        <Stack direction="column" spacing={1}>
          <MaterialTypography variant="caption" color="dark">
            Write Permission
          </MaterialTypography>
          <Autocomplete
            multiple
            options={teamMembersData || []}
            getOptionLabel={(option) =>
              `${option?.employee_name || ""} (${option?.team || "No Team"})`
            }
            value={newFile.writePermission || []}
            onChange={handleWriteFileMemberChange}
            filterSelectedOptions
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  key={option?.id || index}
                  label={`${option?.employee_name || ""} (${option?.team || "NO Team"})`}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} placeholder="Add write members" />
            )}
          />
        </Stack>
      </Grid>

      {/* Upload File */}
      <Grid size={{xs:12,sm:12,md:12}}>
        <Stack direction="column" spacing={1}>
          <MaterialTypography variant="caption" color="dark">
            Upload File
          </MaterialTypography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                border: "2px dotted darkblue",
                backgroundColor: "#e6f2ff",
                borderRadius: "8px",
                width: 500,
                height: 120,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => document.getElementById("fileInput").click()}
            >
              <CloudUpload sx={{ fontSize: 70, color: "darkblue", mb: 1 }} />
              <MaterialTypography variant="caption" color="dark">
                Click to Upload
              </MaterialTypography>
              <input
                id="fileInput"
                type="file"
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Box>
          </Box>

          {/* Show Uploaded Files */}
          
            {Array.isArray(selectedFiles) && selectedFiles.length > 0 &&(
            // <Stack direction="column" spacing={1} sx={{ mt: 2 }}>
            //   {selectedFiles.map((file, index) => (
            //     <Stack
            //       key={index}
            //       direction="row"
            //       spacing={1}
            //       alignItems="center"
            //       justifyContent="space-between"
            //       sx={{
            //         border: "1px solid #ccc",
            //         borderRadius: "6px",
            //         padding: "4px 8px",
            //       }}
            //     >
            //       <MaterialTypography variant="caption" color="dark">
            //         {file.name}
            //       </MaterialTypography>
            //       <IconButton
            //         color="error"
            //         size="small"
            //         onClick={() => handleDeleteFile(file.name)}
            //       >
            //         <Delete fontSize="small" />
            //       </IconButton>
            //     </Stack>
            //   ))}
            // </Stack>
            <MaterialTypography variant="caption" sx={{mt:1}}>
               Uploaded file :{selectedFiles.map((file)=> file.name).join(",")}
            </MaterialTypography>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default NewFile;
